import { render, staticRenderFns } from "./ProfileEditNewItemBtn.vue?vue&type=template&id=04a9e5ea&scoped=true&lang=pug&"
import script from "./ProfileEditNewItemBtn.vue?vue&type=script&lang=js&"
export * from "./ProfileEditNewItemBtn.vue?vue&type=script&lang=js&"
import style0 from "./ProfileEditNewItemBtn.vue?vue&type=style&index=0&id=04a9e5ea&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a9e5ea",
  null
  
)

export default component.exports